import { Button, Checkbox, Input } from 'antd';
import type { FilterDropdownProps } from 'antd/es/table/interface';
import { space } from '@viq-admin/ui';
import { BLANK, GRID_COPY } from './leadGridCopy';

/**
 * The Batch grid's free-text column filter (Name, Email, Phone, Notes): a
 * "Contains…" box plus "Only blank", confirmed with OK or Enter. Rendered by
 * antd as a column's `filterDropdown`; `searchFilterProps` in
 * `leadGridSortFilter` wires it up.
 */
export function SearchFilterDropdown({ selectedKeys, setSelectedKeys, confirm, clearFilters }: FilterDropdownProps) {
  const blankOnly = selectedKeys[0] === BLANK;
  return (
    // antd's dropdown wrapper already stops Enter and clicks reaching the
    // header cell (which would toggle its sort); stopping every key here as
    // well keeps typing from ever reaching it.
    <div style={{ padding: space.sm, width: 240 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        autoFocus
        allowClear
        placeholder={GRID_COPY.containsPlaceholder}
        disabled={blankOnly}
        value={blankOnly ? '' : ((selectedKeys[0] as string | undefined) ?? '')}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ marginBottom: space.sm }}
      />
      <Checkbox
        checked={blankOnly}
        onChange={(e) => setSelectedKeys(e.target.checked ? [BLANK] : [])}
        style={{ marginBottom: space.sm }}
      >
        {GRID_COPY.onlyBlank}
      </Checkbox>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          size="small"
          type="link"
          disabled={selectedKeys.length === 0}
          onClick={() => {
            clearFilters?.();
            confirm();
          }}
        >
          {GRID_COPY.reset}
        </Button>
        <Button size="small" type="primary" onClick={() => confirm()}>
          {GRID_COPY.ok}
        </Button>
      </div>
    </div>
  );
}
